import script from "./TheRefunds.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRefunds.vue?vue&type=script&setup=true&lang=js"

import "./TheRefunds.vue?vue&type=style&index=0&id=fa13d8b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa13d8b2"]])

export default __exports__